import { useState, useEffect    }   from 'react'
import { useBackOffice          }   from '../../contexts/BackOfficeContext.js'
import { usePushNotifications   }   from '../../contexts/PushNotificationsContext.js'

import UserForm                     from './UserForm.js'
import api                          from '../../services/api.js'

function UserFormContainer(){

    const {

        userModalOpen,
        editingUser,
        groups,
        handlerUserModalClose,
        handlerUpdateUserTable

    } = useBackOffice()

    const { setContentPushNotification }                    = usePushNotifications()
    const [railways, setRailways]                           = useState([])
    const [loading, isLoading]                              = useState(true)
    const [salvando, setSalvando]                           = useState(false)

    const isEditMode = !!editingUser

    useEffect(() => {

        fetchRailways()

    }, [])


    useEffect(() => {

        if (groups && groups[0]) {

            isLoading(false);

        }

    }, [groups]);


    const fetchRailways = async () => {

        try{

            const response = await api.get('/getAllRailways', {
                timeout: 7000,
            })

             const formatted = response.data.map(item => ({
                value: item.id,
                label: item.name,
            }));

            setRailways(formatted)

        }catch(error){
            console.log(error)
            setContentPushNotification({title: 'Erro', message: 'Falha ao buscar ferrovias'})
        }
    }

    // O erro do backend vem ora como { message }, ora como string solta
    // (o /createUser responde com o texto puro). Mostrar o motivo real importa:
    // "Username já está em uso por outro usuário" resolve sozinho, "Falha ao
    // salvar" manda a pessoa adivinhar.
    const motivoDoErro = (error, padrao) => {
        const corpo = error?.response?.data
        if (typeof corpo === 'string' && corpo) return corpo
        return corpo?.message || padrao
    }

    const handlerSubmit = async (dadosDoFormulario) => {

        // Os selects guardam { value, label }; a API espera o id.
        const userData = {
            fullName:    dadosDoFormulario.fullName,
            email:       dadosDoFormulario.email,
            username:    dadosDoFormulario.username,
            userGroupId: dadosDoFormulario.userGroupId?.value,
            railwayId:   dadosDoFormulario.railwayId?.value
        }

        try {

            setSalvando(true)

            if (isEditMode) {

                await api.put('/updateUser', { userId: editingUser.id, userData })

                // O token de quem já está logado carrega as permissões do grupo
                // antigo até expirar — quem edita precisa saber disso para não
                // achar que a mudança não pegou.
                const trocouDeGrupo = editingUser.userGroupId !== userData.userGroupId

                setContentPushNotification({
                    title: 'Sucesso',
                    message: trocouDeGrupo
                        ? 'Usuário atualizado. O grupo novo vale a partir do próximo login da pessoa.'
                        : 'Usuário atualizado com sucesso.'
                })

            } else {

                await api.post('/createUser', {
                    userData: { ...userData, password: dadosDoFormulario.password }
                })

                setContentPushNotification({title: 'Sucesso', message: 'Usuário criado com sucesso.'})
            }

            handlerUserModalClose()
            handlerUpdateUserTable()

        }catch(error){
            console.log(error)
            setContentPushNotification({
                title: 'Erro',
                message: motivoDoErro(error, isEditMode ? 'Falha ao editar usuário' : 'Falha ao criar usuário')
            })
        }finally{
            setSalvando(false)
        }
    }

    // Montado só enquanto aberto, e remontado a cada usuário: assim o
    // formulário nunca abre com sobra do que estava carregado antes.
    if (!userModalOpen) return null

    return (

        <UserForm
            key={editingUser?.id ?? 'novo'}
            isOpen={userModalOpen}
            onClose={handlerUserModalClose}
            isEditMode={isEditMode}
            initialValues={editingUser}
            groups={groups}
            railways={railways}
            onSubmit={handlerSubmit}
            loading={loading}
            salvando={salvando}
        />

    )
}

export default UserFormContainer;
